import { createFeatureSelector } from '@ngrx/store';

import { WidgetsState, widgetsFeatureName } from '@shared/widgets/store/state/widgets.state';

export const widgetsRootSelector = createFeatureSelector<WidgetsState>(widgetsFeatureName);
